import { PolylineRounded } from "@mui/icons-material";
import { Backdrop, Box, SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { NewNodeDialog } from "../Dialogs/newNodeDialog";
import { DeleteElementDialog } from "../Dialogs/deleteElementDialog";
import { useState, useRef } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

export const ProjectSpeeddial = (props) => {

  const [showNewNodeDialog, setShowNewNodeDialog] = useState(false);
  const [showDeleteNodeDialog, setShowDeleteNodeDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [newNodeType, setNewNodeType] = useState("");
  const canvasRef = useRef(null);


  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleAddElement = (type) => {
    setOpen(false);
    setNewNodeType(type);
    setShowNewNodeDialog(true);
  }

  const handleDeleteElement = () => {
    setOpen(false);
    setShowDeleteNodeDialog(true);
  }

  const actions = [
    { icon: <ArrowCircleUpIcon />, name: 'Parent', action: () => { handleAddElement("PARENT"); } },
    { icon: <ArrowCircleDownIcon />, name: 'Child', action: () => { handleAddElement("CHILD"); } },
    { icon: <PolylineRounded />, name: 'Connection', action: () => {props.startConnection(); } },
    { icon: <DeleteIcon />, name: 'Delete', action: () => { handleDeleteElement(); } },
  ];
  
  return (
    <>
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: 'absolute', bottom: 16, right: 16, maxWidth: "230px" }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            TooltipClasses={{ maxWidth: "300px" }}
            onClick={action.action}
          />
        ))}
      </SpeedDial>
      <NewNodeDialog type={newNodeType} open={showNewNodeDialog} handleClose={() => setShowNewNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} />
      <DeleteElementDialog open={showDeleteNodeDialog} handleClose={() => setShowDeleteNodeDialog(false)} refreshLayout={() => props.canvasRef.current.setLayout()} />
    </>
  );
}